import { render, staticRenderFns } from "./modal-resolver-paciente-duplicado-backoffice.vue?vue&type=template&id=f946f936"
import script from "./modal-resolver-paciente-duplicado-backoffice.vue?vue&type=script&lang=ts"
export * from "./modal-resolver-paciente-duplicado-backoffice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports